module.exports = __webpack_public_path__ + "img/motor_no60.c3825f5f.jpg";